import React from "react";

//#region src/icons/SearchIcon.tsx
function SearchIcon({ size = 20, color = "currentColor" }) {
	return /* @__PURE__ */ React.createElement("svg", {
		width: size,
		height: size,
		className: "DocSearch-Search-Icon",
		viewBox: "0 0 24 24",
		"aria-hidden": "true"
	}, /* @__PURE__ */ React.createElement("circle", {
		cx: "11",
		cy: "11",
		r: "8",
		stroke: color,
		fill: "none",
		strokeWidth: "1.4"
	}), /* @__PURE__ */ React.createElement("path", {
		d: "m21 21-4.3-4.3",
		stroke: color,
		fill: "none",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
}

//#endregion
//#region \0@oxc-project+runtime@0.139.0/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r, e) {
	if (null == r) return {};
	var t = {};
	for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
		if (e.includes(n)) continue;
		t[n] = r[n];
	}
	return t;
}

//#endregion
//#region \0@oxc-project+runtime@0.139.0/helpers/esm/objectWithoutProperties.js
function _objectWithoutProperties(e, t) {
	if (null == e) return {};
	var o, r, i = _objectWithoutPropertiesLoose(e, t);
	if (Object.getOwnPropertySymbols) {
		var s = Object.getOwnPropertySymbols(e);
		for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
	}
	return i;
}

//#endregion
export { SearchIcon as n, _objectWithoutProperties as t };
//# sourceMappingURL=objectWithoutProperties-phqYxDS0.js.map